import React from 'react';

interface TrialPaymentDescriptionProps {
    className?: string;
    style?: React.CSSProperties;
}

const TrialPaymentDescription: React.FC<TrialPaymentDescriptionProps> = ({
    className = 'text-sm md:text-base',
    style,
}) => {
    return (
        <p className={className} style={style}>
            Enter your payment details to activate your 7-day free trial. If you cancel your
            subscription before the trial ends, you can still complete the 7-day free trial and you
            will not be charged.
        </p>
    );
};

export default TrialPaymentDescription;
